import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'

import {
  Home, Pokemon, Favorite
} from "./pages"

import Navbar from "./components/Navbar"
import { Provider } from 'react-redux';
import store from './store/index';

export function AppRouter() {
  return (
    <Provider store={store}>
    <Switch>
      <Route path="/pokemon">
        <Pokemon />
      </Route>
      <Route path="/favorite">
        <Favorite />
      </Route>
      <Route path="/">
        <Home />
      </Route>
    </Switch>
    </Provider>
  )
}

export default function App() {
  return (

      <Router>
        <Navbar/>
        <AppRouter />
      </Router>
  )
}


